@if (!edit) {
  <h1 mat-dialog-title>Grammatik erstellen</h1>
}
@if (edit) {
  <h1 mat-dialog-title>Grammatik bearbeiten</h1>
}
<mat-dialog-content style="padding: 20px 24px 20px 24px" class="custom-scrollbar w800">
  @if (edit) {
    <app-folder-usage-hint [entryId]="entry?.id" [type]="folderItemType"></app-folder-usage-hint>
  }
  <form [formGroup]="grammarEntryFormGroup">
    <mat-form-field appearance="outline" class="w18 marg-right2">
      <mat-label>Niveau</mat-label>
      <mat-select formControlName="productiveCtrl" placeholder="">
        <mat-option>&mdash;</mat-option>
        @for (option of levelList; track option) {
          <mat-option [value]="option">{{option}}</mat-option>
          } <!-- TODO fix not selected-->
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w32 marg-right2">
        <mat-label>Name</mat-label>
        <input formControlName="nameCtrl" matInput placeholder="" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w46 clickable" (click)="openCategorySelectionDialog()">
        <mat-label>Thema</mat-label>
        <mat-select formControlName="categoryCtrl" multiple placeholder="">
          @for (option of [selectedCategory]; track option) {
            <mat-option [value]="option?.id">
              {{option?.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w100">
        <mat-label>Beispiel</mat-label>
        <input formControlName="exampleCtrl" matInput placeholder="" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w100">
        <mat-label>Kommentar</mat-label>
        <textarea formControlName="commentCtrl" matInput placeholder=""></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="save()" [disabled]="
    grammarEntryFormGroup.controls.nameCtrl.hasError('required')" color="primary"
      mat-raised-button>Speichern
    </button>
  </mat-dialog-actions>
